import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { SearcherComponent } from './searcher.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
  declarations: [SearcherComponent],
  imports: [CommonModule, FormsModule, DropzoneModule, NgxJsonViewerModule],
  exports: [SearcherComponent],
})
export class SearcherModule {}
